/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { NoAccessModule } from './no-access.module';
export { NoAccessComponent } from './no-access.component';